import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaWhatsapp, FaTiktok, FaYoutube } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-content">
          <div className="footer-info">
            <h3>Saldae Voyage</h3>
            <p>Votre partenaire de confiance pour tous vos voyages et démarches administratives.</p>
            
            <div className="footer-contact">
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>En face de la fac Targa Ouzemour, portail sis marché Edimco, Béjaïa 06000</span>
              </div>
              
              <div className="contact-item">
                <FaPhone />
                <span>044 22 00 58 / 07 74979498</span>
              </div>
              
              <div className="contact-item">
                <FaEnvelope />
                <span>contact@saldaevoyage.com</span>
              </div>
            </div>
          </div>
          
          <div className="footer-links">
            <h3>Liens rapides</h3>
            <ul>
              <li><a href="#home">Accueil</a></li>
              <li><a href="#about">À propos</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#testimonials">Témoignages</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-services">
            <h3>Nos services</h3>
            <ul>
              <li>Billetterie & Voyages organisés</li>
              <li>Études à l'étranger</li>
              <li>Démarches touristiques & Visa</li>
              <li>Contrats de travail</li>
            </ul>
          </div>
          
          <div className="footer-social">
            <h3>Suivez-nous</h3>
            <div className="social-links">
              <motion.a 
                href="https://www.facebook.com/saldaevoyage" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ y: -5, scale: 1.1 }}
              >
                <FaFacebook />
              </motion.a>
              
              <motion.a 
                href="https://wa.me/213658149463" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ y: -5, scale: 1.1 }}
              >
                <FaWhatsapp />
              </motion.a>
              
              <motion.a 
                href="https://www.tiktok.com/@saldaevoyage" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ y: -5, scale: 1.1 }}
              >
                <FaTiktok />
              </motion.a>
              
              <motion.a 
                href="https://www.youtube.com/saldaevoyage" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{ y: -5, scale: 1.1 }}
              >
                <FaYoutube />
              </motion.a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {currentYear} Saldae Voyage. Tous droits réservés.</p>
          <div className="footer-legal">
            <a href="#privacy">Politique de confidentialité</a>
            <a href="#terms">Conditions d'utilisation</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 